import { axiosInstance } from "../axios/axiosConfig";
import { REVIEWS_API } from "../constants/api-constants";

const SKIP_LOADING = { headers: { "X-Skip-Loading": true } };

// Latest public learner reviews (rating >= 4, newest first) for the home "Stories" section.
// Anonymous-safe (backend endpoint is [AllowAnonymous]). Returns [] on any error.
export const getPublicReviews = async (count = 10) => {
  try {
    const res = await axiosInstance.get(REVIEWS_API.PUBLIC, { params: { count }, ...SKIP_LOADING });
    return Array.isArray(res.data) ? res.data : [];
  } catch {
    return [];
  }
};
